import type { OfferRow } from './extra-offer-data'
export const AGREEMENT_WORDS = 'Happy to hear about other jobs'
export const BOOKING_OTHER_JOBS = "I'll mention my gutter and conservatory roof cleaning now and then. Just say if you'd rather not."
export const BOOKING_OTHER_JOBS_NOTICE = "I'll also message you here now and then about gutter clearing and conservatory roof cleaning. If you'd rather not get those messages, just reply and let me know."
export const OFFER_ENDING = "Don't fancy getting these offers? Just message me back and I'll stop sending them."
export type BookingOtherJobs = 'fine' | 'no' | null
export function withOfferEnding(words:string):string {
  const clean=words.split(OFFER_ENDING).join('').trimEnd()
  // Keep the opt-out with the offer, before the owner's closing words. Repeated
  // send checks must neither duplicate it nor move it below the signature.
  const closing=clean.search(/(?:^|\n)(?:Kind regards,|Best wishes,|Regards,|Thanks,)\s*\n/i)
  if(closing>=0)return `${clean.slice(0,closing).trimEnd()}\n\n${OFFER_ENDING}\n\n${clean.slice(closing).trimStart()}`
  return `${clean}\n\n${OFFER_ENDING}`
}
// This only offers a question to the owner. It never changes permission by itself.
export function looksLikeOfferNo(words:string):boolean {
 const text=words.trim()
 return /^(?:no|nope|nah)[.!]*$/i.test(text)
  || /\b(?:no[ ,.!]*thanks|no[ ,.!]*thank you|rather not|prefer not|no more (?:offers|messages)|don['’]?t (?:want|send|message)|not interested|only (?:the )?windows|just (?:the )?windows)\b/i.test(text)
  || /\bstop(?!\s+by\b)(?:\s+(?:the|these|your|sending|messaging|offers|messages|me|them|please)){0,8}[.!]*$/i.test(text)
}
export interface OfferStopSuggestion {id:number;body:string;at:string}
export const OFFER_CHANNELS = ['text', 'whatsapp', 'email', 'copy', 'manual'] as const
export interface OfferAgreement {
 id: number; state: 'not_asked' | 'agreed' | 'revoked'; agreement_date: string; recorded_at: string; recorded_by: string
 source: string; wording: string; wording_version: number; channels_json: string; version: number
}
export interface CustomerOffer extends OfferRow {
 booking_key: string | null; customer_id: number; name?: string; accepted_json: string | null; accepted_insides: number
 acceptance_state: 'waiting' | 'none' | 'some' | 'all'; target_visit_id: number | null; target_date: string | null
 send_channel: string; replied_at: string | null; apply_before_json: string | null; applied_version: number | null
}
export interface JobIdea { id: number; service: string; source_field: string; source_words: string; source_visit_id?:number|null }
export interface OfferFacts { agreement: OfferAgreement | null; offers: CustomerOffer[]; ideas: JobIdea[]; stopped: boolean; stop_suggestion?: OfferStopSuggestion | null }
